import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import PillarGuides from "./components/PillarGuides";
import HomeSections from "./components/HomeSections";
import JsonLd from "@/components/feature/JsonLd";
import { SITE_URL, SITE_TITLE, SITE_DESCRIPTION } from "@/lib/seo";

export default function Home() {
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: SITE_TITLE,
    url: `${SITE_URL}/`,
    description: SITE_DESCRIPTION,
  };

  return (
    <div id="top" className="min-h-screen bg-background-50">
      <JsonLd data={webPageSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <PillarGuides />
        <HomeSections />
      </main>
      <Footer />
    </div>
  );
}